import { Switch, Route, Redirect, BrowserRouter } from 'react-router-dom';
import { routes, routePath } from './routes';
import { useSelector } from 'react-redux';
import { storeIsInit } from 'Stores/App';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'Stores';
import GlobalComponents from './GlobalComponents';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import { RouteChangeTracker } from 'Components';
import { isLoginDisabled } from 'Config';

/**
 * Giriş kapalıyken router'dan tamamen çıkarılan adresler.
 *
 * ⚠️ Route'u Switch'e HİÇ EKLEMEMEK bilinçli bir tercihtir; `PrivateRoute`
 * içine koşul yazmak yetmezdi, çünkü o bileşen şu an `hasAccess` kontrolünü
 * bypass ediyor. Eşleşen route bulunmayınca aşağıdaki catch-all devreye girer
 * ve kullanıcı karşılama ekranına yönlendirilir.
 */
const disabledPaths: string[] = isLoginDisabled ? [routePath.login, routePath.signup] : [];

const isRouteDisabled = (path?: string | string[]): boolean => {
  if (!path) return false;
  const paths = Array.isArray(path) ? path : [path];
  return paths.some((p) => disabledPaths.includes(p));
};

const Navigator = () => {
  const appIsInit = useSelector(storeIsInit);

  return (
    <>
      <ConnectedRouter history={history}>
        {appIsInit && (
          <Switch>
            {routes
              .filter(({ path }) => !isRouteDisabled(path))
              .map(({ component, exact, path, isPrivate }, index) =>
                isPrivate ? (
                  <PrivateRoute key={index} path={path} component={component} exact={exact || false} />
                ) : (
                  <PublicRoute key={index} path={path} component={component} exact={exact || false} />
                )
              )}
            <Route render={() => <Redirect to={routePath.welcome} />} />
          </Switch>
        )}

        {appIsInit && <GlobalComponents />}
        <RouteChangeTracker />
      </ConnectedRouter>
    </>
  );
};

export default Navigator;
